// extracted by mini-css-extract-plugin
export default {"cognitoContainer":"CognitoContainer_cognitoContainer__O3Clv"};